<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card>

      <v-card-title class="title grey lighten-2" primary-title>
        担当登録
      </v-card-title>

      <v-card-text>

        <v-text-field
            v-model="name"
            counter="50"
            hint=""
            label="担当氏名"
        ></v-text-field>

        <v-text-field
            v-model="tel"
            counter="50"
            hint=""
            label="TEL"
        ></v-text-field>

        <v-text-field
            v-model="email"
            counter="50"
            hint=""
            label="EMAIL"
        ></v-text-field>

        <v-switch
            v-model="keyPerson"
            label="キーパーソン"
        ></v-switch>
      <!-- key_person -->

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>

        <v-btn color="primary" elevation="0" @click.native="onSaveClick">追加</v-btn>
        <v-btn color="normal" elevation="0" @click.native="cancel">キャンセル</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "@/components/dialogs/BaseDialog";

export default {
  mixins:[BaseDialog],
  components: {},
  props: [],
  data() {
    return {
      name:"",
      email:"",
      keyPerson:false,
      tel:"",
    };

  },
  methods: {

    open(data,options) {

      this.name = data.name;
      this.email = data.email;
      this.keyPerson = (data.keyPerson == 1);
      this.tel = data.tel;

      this.options = Object.assign(this.options, options); // 使っていないけど一応

      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSaveClick(){
      this.resolve({
        name:this.name,
        email:this.email,
        keyPerson:(this.keyPerson ? 1 : 0),
        tel:this.tel,
      });
      this.dialog = false;
    },

  },

}
/*
// 呼び出し方法
// https://qiita.com/ta1nakamura/items/f844dd2437af8ecc5674
async onClickOpen(){
  console.log('--onClickOpen')
  if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
    console.log('--yes')
  }else{
    console.log('--no')
  }
}
* */
</script>
